import { IconRefreshCcw } from '@iwoca/icons';
import { IconEmailReceived } from '@iwoca/icons/brand';
import { Stack, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const IdCheckSmsSent = ({
    name,
    sentNumber,
    onResend
}: {
    name?: string;
    // Unknown after a reload, as the requirements don't say which phone the SMS went to.
    sentNumber?: string;
    onResend: () => void;
}) => (
    // ORION-113-GAP off-system: text alignment, not layout
    <Stack gap="section" align="center" className="text-center">
        <Stack align="center">
            <IconEmailReceived fontSize={40} />
            <Text className="text-3xl font-bold">
                {name ? (
                    <FormattedMessage
                        id="_.funding_requirements_v2.id_verification.sent_title_multiple"
                        defaultMessage="{name} has received an SMS"
                        values={{
                            name: <span className="fs-exclude">{name}</span>
                        }}
                    />
                ) : (
                    <FormattedMessage
                        id="_.funding_requirements_v2.id_verification.sent_title"
                        defaultMessage="You’ve received an SMS"
                    />
                )}
            </Text>
            <Text className="text-xl">
                {sentNumber ? (
                    <FormattedMessage
                        id="_.funding_requirements_v2.id_verification.sent_to_number"
                        defaultMessage="Please follow the next steps we sent by SMS to {number}."
                        values={{
                            number: (
                                <strong className="fs-exclude">
                                    {sentNumber}
                                </strong>
                            )
                        }}
                    />
                ) : (
                    <FormattedMessage
                        id="_.funding_requirements_v2.id_verification.sent_next_steps"
                        defaultMessage="Please follow the next steps we sent you by SMS."
                    />
                )}
            </Text>
        </Stack>
        <Text>
            <FormattedMessage
                id="_.funding_requirements_v2.id_verification.sent_delay"
                defaultMessage="It may take a moment for the SMS to arrive. Check your signal. Once you’ve completed the steps, come back to this page."
            />
        </Text>
        {/* ORION-113-GAP off-system: hand-styled outline pill button instead of an Orion Button variant; its inner layout and size stay as classes */}
        <button
            type="button"
            onClick={onResend}
            className="flex min-h-[52px] items-center gap-m rounded-full border border-primary-10 px-l text-l font-bold text-primary-10 hover:bg-structure-95"
        >
            <FormattedMessage
                id="_.funding_requirements_v2.id_verification.resend_sms"
                defaultMessage="Resend SMS"
            />
            <IconRefreshCcw className="text-xl" />
        </button>
    </Stack>
);
